export default "__VITE_ASSET__f0fa268b__"